import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@pkgs/components/hooks/stores/search/slices/optionsSlice';
import { DEFAULT_OPTIONS } from '@pkgs/api/utils/filters';
import { MarketCountryCode, type SearchListingsOptions } from '@pkgs/api';

export const INTIAL_OPTIONS: Required<SearchListingsOptions> = {
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  language: DEFAULT_OPTIONS.language,
  measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  currency: DEFAULT_OPTIONS.currency,
  marketCountryCode: MarketCountryCode.DE,
};
